import { Contact } from "./contacts.types";

/**
 * The API sets `assigned_to_case` only when the request carried
 * `assigned_case_id`. A missing value therefore means "not asked" or "API
 * predates the flag", never "not assigned" — so an explicit 1 is the only thing
 * that marks a contact as already on the case, and a caller that never asked
 * behaves exactly as it did before the flag existed.
 */
export const isAssignedToCase = (contact: Contact) =>
  Number(contact.assigned_to_case) === 1;

/**
 * Whether a contact may be picked. Shaped for `resolveSelection`'s
 * `isSelectable` and List's `isItemSelectable`, which share a contract: an
 * explicit `false` rejects the contact, so this must return a real boolean.
 */
export const isSelectableContact = (contact: Contact): boolean =>
  !isAssignedToCase(contact);
